import React from "react";

export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    'hy_AM': 'Armenian (Armenia)',
    // GAME_SUSPENDED_MESSAGE: 'Game {0} is currently suspended...',  {0} = game name EXAMPLE WITH WILD CARD market types
    WIN_DRAW_WIN: 'Խաղի արդյունք',
    CORRECT_SCORE: 'Ճշգրիտ հաշիվ',
    TOTAL_GOALS: 'Գոլերի տոտալ',
    DOUBLE_CHANCE: 'Կրկնակի հնարավորություն',
    UNDER_OVER: 'Շատ/Քիչ',
    UNDER_OVER_25: 'Շատ/Քիչ 2.5',
    UNDER_OVER_25_INITIALS: 'Շատ/Քիչ 2.5',
    UNDER_OVER_35_INITIALS: 'Քիչ/Շատ 3.5',
    UNDER_OVER_15: 'Շատ/Քիչ 1.5',
    ASIAN_HANDICAP: 'Asian Handicap',
    HANDICAP: '1X2 հանդիկապ',
    HANDICAP_FIRST: '1X2 հանդիկապ Տանտերեր +1',
    HANDICAP_SECOND: '1X2 հանդիկապ Հյուրեր +1',
    UNDER_OVER_05: 'ցածր/ բարձր 0.5',
    UNDER_OVER_35: 'Շատ/Քիչ 3.5',
    BOTH_TEAMS_SCORE: 'Երկու թիմերն էլ գոլ կխփեն',
    BOTH_TEAMS_SCORE_INITIALS: 'BTTS',
    HOME_TEAM_GOALS: '{0} Team Goals',
    AWAY_TEAM_GOALS: '{1} Team Goals',
    MATCH_BETTING_BOTH_TEAMS_SCORE: 'Match Betting Both Teams Score',
    WINNING_MARGIN: 'Շահումի մարժա',
    CORRECT_SCORE_GROUP: 'Ճիշտ միավորների խումբ',
    HOME_TEAM_TO_SCORE: '{0} To Score',
    AWAY_TEAM_TO_SCORE: '{1} To Score',
    FIRST_TEAM_TO_SCORE: 'Առաջին թիմը գոլ կխփի',
    LAST_TEAM_TO_SCORE: 'Վերջին թիմը գոլ կխփի',
    HALF_TIME_FULL_TIME: 'Խաղակես / Մրցախաղ (Ամբողջ խաղ)',
    TEAM_SCORECAST: 'Team Scorecast',
    HALF_TIME_CORRECT_SCORE: 'Half Time Correct Score',
    HALF_TIME_RESULT: 'Խաղակեսի արդյունք',
    FIRST_LAST_TO_SCORE: 'Առաջինը / Վերջինը գոլ խփողը',
    LAST: 'Վերջին',
    FIRST: 'Առաջին',
    IN: 'in',
    LAST_THREE_GAMES: 'Last 3 Games',
    PREVIOUS: 'Նախորդ',
    EIGHT_RESULTS: '8 հանդիպում',
    EIGHT_GAMES: '8 խաղ',
    OVER_25: 'Բարձր 2.5',
    UNDER_25: 'ցածր 2.5',
    OVER_35: 'Բարձր 3.5',
    UNDER_35: 'ցածր 3.5',
    COVERED: 'Ներառված',
    DID_NOT_COVER: 'Ներառված չէ',
    SPREAD: 'Տարածում',
    TOTAL_POINTS_UNDER_OVER: 'Միավորների ընդհանուր քանակը Քիչ/Շատ',
    TOTAL_POINTS_OVER_UNDER: 'Միավորների ընդհանուր քանակը Շատ/Քիչ',
    MONEYLINE: 'Դրամական գիծ',
    TOTAL_POINTS_GROUP: 'Միավորների ընդհանուր քանակ խումբ',
    MONEY_LINE_TOTAL_POINTS: 'Դրամական գիծ և ընդհանուր միավորներ Քիչ/Շատ',
    SPREAD_TOTAL_POINTS: 'Տարածում և ընդհանուր միավորներ Քիչ/Շատ',
    // countries (these are lowecase and strings on purpose)
    'Argentina': 'Argentina',
    'Belgium': 'Belgium',
    'Brazil': 'Brazil',
    'Colombia': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatia',
    'Czech Republic': 'Czech Republic',
    'Denmark': 'Denmark',
    'Egypt': 'Egypt',
    'England': 'England',
    'France': 'France',
    'Germany': 'Germany',
    'Greece': 'Greece',
    'Holland': 'Holland',
    'Iceland': 'Iceland',
    'Italy': 'Italy',
    'Mexico': 'Mexico',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'Republic of Ireland': 'Republic of Ireland',
    'Russia': 'Russia',
    'Spain': 'Spain',
    'Sweden': 'Sweden',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukraine',
    'Uruguay': 'Uruguay',
    //Basketball US Teams
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    //Basketball Euro Teams
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    //Euro 2020 teams
    'Turkey': 'Turkey',
    'Netherlands': 'Netherlands',
    //Super league
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    //NFLA
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',

    // market specific words
    'DRAW': 'Ոչ ոքի',
    'HD': '{0}/Ոչ ոքի',
    'DA': 'Ոչ ոքի/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'ցածր 2.5',
    'Over 2.5': 'Բարձր 2.5',
    'Under 1.5': 'ցածր 1.5',
    'Over 1.5': 'Բարձր 1.5',
    'Under': 'Քիչ {0}',
    'Over': 'Շատ {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'ցածր 0.5',
    'Over 0.5': 'Բարձր 0.5',
    'Under 3.5': 'ցածր 3.5',
    'Over 3.5': 'Բարձր 3.5',
    'Both Score Yes': 'Այո',
    'Both Score No': 'Ոչ',
    'Home Not to Score': '{0} Not to Score',
    'Home Exactly 1': '{0} Exactly 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Not to Score',
    'Away Exactly 1': '{1} Exactly 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} to Win and both teams to score',
    'Home to Win to nil': '{0} to Win to nil',
    'Score draw': 'Score draw',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} to Win and both teams to score',
    'Away to Win to nil': '{1} to Win to nil',
    'Home Win By Exactly 1 Goal': '{0} Win By Exactly 1 Goal',
    'Home Win By Exactly 2 Goals': '{0} Win By Exactly 2 Goals',
    'Home Win By 3 or more goals': '{0} Win By 3 or more goals',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Draw With No Goals',
    'Draw With Goals': 'Draw With Goals',
    'Any Other': 'Any Other',
    'Home Not To Score': '{0} Not To Score',
    'Home To Score': '{0} To Score',
    'Away Not To Score': '{1} Not To Score',
    'Away To Score': '{1} To Score',
    'Home': '{0}',
    'No Goal': 'Գոլեր չկան',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Ոչ ոքի',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Ոչ ոքի/{0}',
    'Draw/Draw': 'Ոչ ոքի/Ոչ ոքի',
    'Draw/Away': 'Ոչ ոքի/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Ոչ ոքի',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Other',
    'Draw': 'Ոչ ոքի',
    // Basketball
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'ցածր 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Բարձր 249',
    //American Football
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'ցածր 26',
    '25 And Under Short': 'ցածր 26',
    '51 And Over': 'Բարձր 50',
    '51 And Over Short': 'Բարձր 50',
    'and': '&',
    'slash': '/',
    // first down
    FIRST_PLAY: '1st Play',
    SECOND_PLAY: '2nd Play',
    THIRD_PLAY: '3rd Play',
    FOURTH_PLAY: '4th Play',
    FIFTH_PLAY: '5th or More Play',
    FIELD_GOAL: 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',

    //Game Tabs
    'Football': 'Ամերիկյան',
    'Matchday': 'Խաղի օր',
    'Basketball': 'Բասկետբոլ',
    'Dogs': 'Շներ',
    'Motor Racing': 'Ավտոմրցարշավ',
    'Results': 'Արդյունքներ',
    'Horses': 'Ձիեր',
    'Soccer': 'Ֆուտբոլ',
    'US Football': 'ԱՄՆ Ֆուտբոլ',
    'Marble Racing': 'Գնդակների մրցավազք',
    "Matchday_English": "Խաղի օր",
    "Matchday_Turkish": "Խաղի օր",
    "Matchday_Greek": "Խաղի օր",
   
    //Game SubTabs
    'Soccer_Euro': 'Եվրո',
    'Soccer_Soccer3_Super_League': 'Սուպերլիգա',
    'Soccer_Soccer3_Greek_League': 'Հունական լիգա',
    'Soccer_Super_League': 'Սուպերլիգա',
    'Soccer_World_Cup': 'Աշխարհի առաջնություն',
    'Soccer_Soccer3_World_Cup': 'Աշխարհի առաջնություն',
    'Horses_Sprints': 'Արագավազք',
    'Horses_Flats': 'Հարթություն',
    "Horses_Jumps": "Ցատկեր",
    "Basketball_US1": "US1",
    "Basketball_US2": "US2",
    "Basketball_Europe": "Եվրոպա",
    "Dogs_Flats": "Հարթություն",
    "Dogs_City": "Ֆիքսված գործակիցներ",
    "Motor_Racing_Stock_Cars": "Stock մեքենաներ",
    "Motor_Racing_Indy_Cars": "Indy մեքենաներ",
    "US_Football_NFLA": "NFLA",
    "US_Football_NFL": "NFL",
    'US_Football_Football': 'Ամերիկյան',
    'Marble_Racing_Marbles': 'Գնդակներ',
    'Marble_Racing_Marbles2': 'Ավազ',
    'Marble_Racing_Marbles_Euro': 'Ֆուտբոլ',
    'Marble_Racing_Marbles_Halloween': 'Հելոուին',
    "Matchday_English_Matchday_English": "Խաղի օր",
    "Matchday_Turkish_Matchday_Turkish": "Խաղի օր",
    "Matchday_Greek_Matchday_Greek": "Խաղի օր",

    //Racing
    FORECAST: 'Forecast',
    TRICAST: 'Tricast',
    REVERSE_FORECAST: 'Համակցված կախատեսում',
    REVERSE_TRICAST: 'Համակցված տրիկաստ',
    FIRST_ST: '1',
    SECOND_ND: '2',
    THIRD_RD: '3',
    RD: 'րդ',
    ST: 'ին',
    ND: 'րդ',
    ANY: 'Any',
    TO_WIN: 'Հաղթել',
    RACE_CARD: 'ՄՐՑԱՐՇԱՎԻ ՔԱՐՏ',
    EACH_WAY: 'Յուրաքանչյուր ուղի',
    EW: 'E/W',
    FORECAST_TRICAST: 'Forecast/Tricast',
    EACH_WAY_ODDS_PLACE: 'E/W {0} 1-2',
    EACH_WAY_ODDS_SHOW: 'E/W {0} 1-2-3',
    EXPAND_ALL: 'Expand Markets',
    COLLAPSE_ALL: 'Collapse Markets',
    NUMBER: 'Համար',
    SORT_BY: 'Դասավորել ըստ',
    BET_SLIP: 'Խաղադրույքի կտրոն',
    CLOSE_BET_SLIP: 'Փակել',
    CLOSE_SLIP: 'Փակել',
    PLACED_BETS: 'Տեղադրված',
    SETTLED_BETS: 'Վճարված',
    SLIP: 'Կտրոն',
    OPEN_BETS: 'Բացել',
    CLEAR_SELECTIONS: 'Մաքրել ընտրանքները',
    ADD_TO_BET_SLIP: 'Ավելացնել խաղադրույքի կտրոնում',
    NO_BETS: 'Խաղադրույքներ չկան',
    COMBINATION_TRICAST: 'Համակցված տրիկաստ',
    COMBINATION_FORECAST: 'Համակցված կախատեսում',
    TOTAL_STAKE: 'Ընդհանուր խաղադրույք',
    TOTAL_POTENTIAL_RETURNS: 'Ընդհանուր պոտենցիալ վերադարձ',
    N_A: 'Կ/Չ',
    PLACE_BETS: 'Կատարել խաղադրույքներ',
    REMOVE_ALL: 'Հեռացնել բոլորը',
    POT_RETURNS: 'Հնար. երադարձ:',
    RETURNED: 'Վերադարձվել է:',
    REFUNDED: 'Վերադարձված գումար',
    OK: 'OK',
    WIN_INITIAL: 'W',
    DRAW_INITIAL: 'D',
    LOSE_INITIAL: 'L',

    //Settings
    SETTINGS: 'Կարգավորումներ',
    LANGUAGE: 'Լեզու',
    LAYOUT: 'Դասավորություն',
    ODDS: 'Գործակիցներ',
    EN_GB: 'English UK',
    DECIMAL: 'Տասնորդական',
    FRACTIONAL: 'Կոտորակային',
    AMERICAN: 'Ամերիկյան',
    SIMPLIFIED_DESKTOP: 'This is The main class for the desktop simplified UI',
    SIMPLIFIED_MOBILE: 'This is The main class for the mobile simplified UI',
    SHOW_VIDEO: 'Show Video',

    //Notifications
    ALERT_NOTIFICATION: 'Զգուշացում',
    WARNING_NOTIFICATION: 'Ուշադրություն',
    WARNING_NOTIFICATION_REALITY_CHECK: 'Ուշադրություն',
    INFO_NOTIFICATION: 'ԻՆՖՈ',
    SUCCESS_NOTIFICATION: 'Հաջողություն',

    SELECTION_REMOVAL: 'Այս ընտրությունը կհեռացվի',
    SECONDS: 'վայրկյաններ',
    SECOND: 'վայրկյան',
    REMOVE_CLOSED_EVENTS: 'Հեռացնել փակված իրադարձությունները',
    SET_VIDEO_ON_FUL_SCREEN: 'Set Video on Full Screen?',
    CANCEL: 'Հեռացնել',

    //Error codes
    INTERNAL_ERROR: 'Ներքին սխալ',
    OPEN_BETS_WARNING: 'Որոշ կամ բոլոր բաց խաղադրույքները չեն կարող ավելացվել խաղաքարտին, քանի որ դրանք պատկանում են անցած իրադարձություններին:',
    '-32602': 'Մեկ կամ մի քանի խաղադրույքներ ժամանակին չեն կատարվել:',
    OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED: 'Կտրոնների ներդիրում խաղադրույքների քանակը հասել է առավելագույնի: Խնդրում ենք հեռացնել կամ կատարել խաղադրույքներ՝ նախքան նորերը ավելացնելը:',

    '-20000': 'Cannot establish connection (Error Code: -20000)', //INIT_NOT_INVOKED
    '-20001': 'Cannot establish connection (Error Code: -20001)', //MISSING_SESSION_TOKEN
    '-20002': 'Too many requests (Error Code: -20002)', //Duplicate single shot invocation
    '-20003': 'Too many requests (Error Code: -20003)', //INVOCATION_FREQUENCY_THRESHOLD_BREACHED
    '-20004': 'Invalid Request (Error Code: -20004)', //A BmsServerAPI command was received, but the params are not compliant with Operator rules.
    '-10000': 'Invalid Request (Error Code: -10000)', //INVALID_SESSION_TOKEN
    '-10001': 'Invalid Request (Error Code: -10001)', //INBOUND_MESSAGE_QUEUE_FULL
    '-1000': 'Խաղը դադարեցվել է։ Խնդրում ենք կապ հաստատել Հաճախորդների աջակցման թիմի հետ:',
    '-999': 'Սեանսն ավարտվել է։',
    '-998': 'Խաղացողը որակազրկվել է',
    '-997': 'Հրամանն անթույլատրելի է',
    '-996': 'Error processing request (Error Code: -996)', //Gaming System Error
    '-995': 'Error processing request (Error Code: -995)', //BMS Internal Error
    '-994': 'Սերվերի հետ կապը խափանվել է, խաղադրույքը չի կատարվել:',
    '-980': 'Error processing request (Error Code: -980)', //Error processing game command.
    '-979': 'Error processing request (Error Code: -979)', //Error on Json message sent by Virgo.
    '-978': 'Այս գործարքն իրականացնելու համար միջոցները բավարար չեն:',
    '-977': 'Իսկության ստուգումը ձախողվեց:',
    '-976': 'Դրամապանակի աշխատանքը ժամանակավորապես արգելափակված է:',
    '-975': 'Պարտությունների սահմանաչափը գերազանցվել է։',
    '-974': 'Պարտությունների սահմանաչափը գերազանցվել է։',
    '-973': 'Սահմանափակում չկա:',
    '-972': 'Պատասխանատու խաղային սխալ։',
    '-971': 'Դրամապանակի աշխատանքը ձախողվեց:',
    '-970': 'Դրամապանակի գործարքը մերժվել է:',
    '-969': 'Դրամապանակի հաղորդակցման սխալ:',
    '-968': 'Դրամապանակի գործարքի սխալ:',
    '-967': 'Նույնականացումը ձախողվեց։',
    '-966': 'Շահումի վերին շեմը գերազանցվել է:',
    '-965': 'Անվավեր պարամետրեր։',

    // BET LIMITS ALERTS
    BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Մեկ կամ մի քանի խաղադրույքներ անվավեր են: Նվազագույն խաղադրույքը՝ {0}, առավելագույն խաղադրույքը՝ {1}: Խնդրում ենք շտկել դա նախքան  խաղադրույքները կատարելը:',
    LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE: 'Stake limits on {0} are Min {1} & Max {2}',
    BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE: 'Մեկ կամ մի քանի խաղադրույքների հնարավոր վերադարձը գերազանցում է {0}-ի առավելագույն վճարումը: Խնդրում ենք շտկել դա նախքան ձեր խաղադրույքները կատարելը:',
    BET_NON_DIVISIBLE_MESSAGE: 'Մեկ կամ մի քանի խաղադրույքներ, որոնք չեն բաժանվում {0}-ի: Խնդրում ենք շտկել դա նախքան  խաղադրույքները կատարելը:',
    SINGLE_BET_COMMIT_MESSAGE: 'Դուք չեք կարող մի քանի առանձին խաղադրույքներ կատարել',
    REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'Ձեր կատարած խաղադրույք(ներ)ը գերազանցում է {0}-ը:',
    MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1: 'The bet(s) you are placing are under {0}',
    REALITY_CHECK_WARNING_MESSAGE_LINE_2: 'Արդյո՞ք սա նորմալ է։',
    REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING: '{0}-ի առավելագույն գումարը խաղադրվել է: Խնդրում ենք ընտրել այլ իրադարձություն',

    //SIMPLIFIED UI
    TOTAL_BETS: 'ԸՆԴՀԱՆՈՒՐ ԽԱՂԱԴՐՈՒՅՔ:',
    PLACE_YOUR_BETS: 'Կատարեք Ձեր խաղադրույքները',
    RACE_START: 'Race Start',
    RACE_START_TIME: 'Start Time',
    BET_SUMMARY: 'Խաղադրույքների ամփոփում',
    NO_BETS_RESUME: 'Ընթացիկ իրադարձության համար խաղադրույքներ չեն կատարվել',
    LIVE: 'LIVE',
    RACERS: 'Ավտոմրցարշավորդներ',
    SELECTION: 'Ընտրություն',
    DATE_LOCATION: 'Իրադարձություն',
    STAKE: 'Խաղադրույք',
    BET_TYPE_STAKE: 'Խաղադրույքի տեսակը/Խաղադրույք',
    POTENTIAL_RETURNS: 'Հնար. երադարձs',
    BET_HISTORY: 'Խաղադրույքի պատմություն',
    BET_HISTORY_LABEL: 'Հետագա պատմությունը տեսնելու համար սեղմեք Խաղադրույքների պատմություն կոճակը',
    FILTER_WINS: 'Զտել հաղթողներին',
    NEXT_RACE: 'Հաջորդ մրցավազքը',
    WIN: 'Հաղթել',
    PLACE: 'Տեղադրել',
    SHOW: 'Ցույց տալ',
    EXACTA: 'Forecast',
    TRIFECTA: 'Tricast',
    NO_WIN: 'ՀԱՂԹՈՂ ՉԿԱ',
    WON: 'ՀԱՂԹԱԾ',
    LOST: 'ՊԱՐՏՎԱԾ',
    CURRENT_RACE: 'Ընթացիկ մրցավազք',
    BOX: 'BOX',
    TO: 'դեպի',
    PAYS: 'վճարումներ',
    TRIFECTA_BOX: 'Համակցված տրիկաստ',
    EXACTA_BOX: 'Համակցված կախատեսում',
    FINISH_YOUR_BETS: 'Ավարտեք Ձեր խաղադրույքները',
    SELECT_YOUR_BET_BELOW: 'Ընտրեք Ձեր խաղադրույքը ստորև',
    BET: 'խադրույք',
    REMOVED: 'հեռացվել է',
    RESULT: 'Արդյունք',
    GOALS: 'Գոլեր',
    NO_MORE_BETS: 'Այլևս խաղադրույքներ չկան',
    EVENT_LIVE_MSG_LINE_1: 'Ընթացիկ իրադարձություն ուղիղ եթերում',
    EVENT_LIVE_MSG_LINE_2: 'Ընտրել ապագա խաղերից ',
    EVENT_LIVE_MSG_LINE_3: 'Իրադարձություններ վերևում',
    NO_FUTURE_EVENTS: 'Բեռնվում է',
    AUTHENTICATION_REQUIRED: 'Շարունակելու համար մուտք գործեք',
    GAME_DISABLED: 'Խաղն անջատվել է',
    GAME_DISABLED_MESSAGE: 'Խնդրում ենք կապ հաստատել Հաճախորդների աջակցման թիմի հետ:',
    VOIDED: 'ՉԵՂԱՐԿՎԱԾ',
    HELP: 'Օգնություն',
    LAST_RESULTS: 'Վերջին արդյունքները',
    NO_LAST_RESULTS: 'Վերջին արդյունքներ չկան',
    PREVIOUS_RESULTS: 'Նախորդ արդյունքները',
    OFFENSE_PREVIOUS_RESULTS: 'Offence Previous Results',
    DEFENSE_PREVIOUS_RESULTS: 'Defence Previous Results',
    NO_LUCK: 'NO LUCK',
    THIS_TIME: 'THIS TIME',
    LOOK_FOR_THE_NEXT: 'Փնտրել հաջորդը',
    SCHEDULED_EVENT: 'պլանավորված իրադարձություն',
    LOOK_FOR_THE: 'Փնտրել',
    NEXT_SCHEDULED: 'հաջորդ պլանավորված',
    EVENT: 'Իրադարձություն',
    RETURNS: 'ՎԵՐԱԴԱՐՁՆԵՐ',
    NEXT: 'Հաջորդ',
    FUTURE: 'Ապագա',
    PLAYING: 'Խաղ',

    //MESSAGE BAR
    ON: 'շարունակվում է',
    MB_RACE_ON: 'շարունակվում է',
    MB_RACE_WIN: 'հաղթել',
    MB_RACE_PLACE: 'տեղադրել',
    MB_RACE_SHOW: 'ցույց տալ',
    MB_RACE_TRIFECTA_BOX: 'Համակցված տրիկաստ',
    MB_RACE_EXACTA_BOX: 'Համակցված կախատեսում',
    MB_RACE_EXACTA: 'Forecast',
    MB_RACE_TRIFECTA: 'Tricast',
    MB_FOOTBALL_ON: 'շարունակվում է',

    // DESKTOP UI
    ADVERTISING_SPACE: 'ADVERTISING SPACE',
    CLEAR_LAST: 'Մաքրել վերջինը',
    CLEAR_ALL: 'Մաքրել բոլորը',
    ACTIVE_BETS: 'Ակտիվ խաղադրույքներ',
    ONLY_SHOW_WINS: 'Ցույց տալ միայն շահումները',
    MORE: 'Ավելին',
    BETS: 'Խաղադրույքներ',
    LOADING: 'Բեռնվում է',
    BET_SELECTION_MESSAGE: 'Կատարեք Ձեր ընտրությունը (ներ)ը՝ սեղմելով գործակիցների վրա:',

    // BUTTONS
    SIMPLE: 'simple',
    EXOTIC: 'exotic',
    UNDO: 'undo',
    CLEAR: 'clear',
    HISTORY: 'պատմություն',

    MARKETS: 'Շուկաներ',
    MAIN: 'Հիմնական',
    VS: 'vs',
    AT: '@',
    SCORE: 'հաշիվ',
    DEFENDS: '(Defends) at',
    ATTACKS: '(Attacks) at',
    DETAILS: 'Մանրամասներ',
    NO_GOALS: 'Գոլեր չկան',

    MAX_WINNINGS_REACHED: 'Հասել է առավելագույն շահումի',
    MAX_WINNINGS_REACHED_TEXT: 'Ընթացիկ խաղադրույքը կգերազանցի {0}-ի առավելագույն վճարումը: Այս խաղադրույքի համար թույլատրված առավելագույն խաղադրույքի արժեքն է {1}:',
    NO_CONNECTION_TITLE: 'Կապը խափանվել է',

    NO_CONNECTION_TITLE_TEXT: 'Սերվերի հետ կապը խափանվել է: Համոզվեք, որ ունեք կայուն ինտերնետ կապ և թարմացրեք էջը: Եթե խնդիրը չվերանա, խնդրում ենք դիմել Հաճախորդների աջակցման թիմ:',
    PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT: 'Միացումը փակ է, օգտատերը միացել է երկու անգամ:',
    BET_CONFIRMED_TEXT:'none',
    TAX_NOTIFICATION_TEXT: 'none',
    //Event title names
    //Football
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',

    //Horses Sprints
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',

    //BasketBall
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',
    //Horses Jumps
    'HorsesJumps': 'Inspired Downs',

    //Dogs
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',

    //Motor Racing
    'Circuit': 'Circuit',

    //Speedway Park
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',

    'NO_CONNECTION_TO_VIRGO': 'Կապը խափանվել է',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Խնդրում ենք թարմացնել էջը և մուտք գործել:',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Ձեր ընթացիկ բրաուզերը չի աջակցվում: Խնդրում ենք օգտագործել հետևյալ բրաուզերներից մեկը՝ Chrome, Firefox կամ Safari:',
    'BROWSER_NOT_SUPPORTED': 'Բրաուզերը չի աջակցվում',
    'DOWNLOAD_CHROME': 'Ներբեռնել Chrome',
    'DOWNLOAD_FIREFOX': 'Ներբեռնել Firefox',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': 'Բարձր 219.5',
    'Under 219.5': 'ցածր 219.5',
    'Over 214.5': 'Բարձր 214.5',
    'Under 214.5': 'ցածր 214.5',
    'Over 209.5': 'Բարձր 209.5',
    'Under 209.5': 'ցածր 209.5',
    'Over 144.5': 'Բարձր 144.5',
    'Under 144.5': 'ցածր 144.5',
    'Over 149.5': 'Բարձր 149.5',
    'Under 149.5': 'ցածր 149.5',
    'Over 154.5': 'Բարձր 154.5',
    'Under 154.5': 'ցածր 154.5',
    'Over 159.5': 'Բարձր 159.5',
    'Under 159.5': 'ցածր 159.5',
    'Over 164.5': 'Բարձր 164.5',
    'Under 164.5': 'ցածր 164.5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'Ավարտման պատվեր',
    'FORECAST_MARBLE': 'Թոփ 2',
    'TRICAST_MARBLE': 'Թոփ 3',
    'REVERSE_FORECAST_MARBLE': 'Թոփ 2 ցանկացած հերթականությամբ',
    'REVERSE_TRICAST_MARBLE': 'Թոփ 3 ցանկացած հերթականությամբ',
    "TO_WIN_MARBLE": "Հաղթել",
    "PLACE_MARBLE": "Տեղադրել",
    "SHOW_MARBLE": "Ցույց տալ",
    "MARBLE": "Գնդակներ",
    "Rumble Turns": "Rumble Turns",
    "Maple Downs": "Maple Downs",

    //Header
    'BALANCE': 'Հաշվեկշիռ',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Wins The Game',
    'Any': 'Any',
    "BET_BOTH": "Երկուսի խաղադրույք",
    //Matchday
    "betSlip_Matchday_English": "Խաղային օր անգլիական",
    "betSlip_Matchday_Turkish": "Matchday Turkish",
    "betSlip_Matchday_Greek": "Matchday Greek",
    "betSlip_Soccer": "Ֆուտբոլ",
    "betSlip_Horses": "Ձիեր",
    "betSlip_Basketball": "Բասկետբոլ",
    "betSlip_Dogs": "Շներ",
    "betSlip_Motor Racing": "Ավտոմրցարշավ",
    "betSlip_US Football": "ԱՄՆ Ֆուտբոլ",
    "betSlip_Marble Racing": "Գնդակների մրցավազք",
    "POS": "pos",
    "TEAM": "թիմ",
    "P": "p",
    "W": "w",
    "D": "d",
    "L": "l",
    "F": "f",
    "A": "a",
    "PTS": "pts",
    "LEAGUE TABLE": "լիգայի աղյուսակ",
    "TREND": "թրենդ",

    //Matchday English Teams
    "Matchday_Islington": "ISL",
    "Matchday_City": "CTY",
    "Matchday_Palace": "PAL",
    "Matchday_Chelsea": "CHE",
    "Matchday_Southampton": "SOU",
    "Matchday_Wolverhampton": "WOL",
    "Matchday_Sheffield": "SHE",
    "Matchday_Leicester": "LEI",
    "Matchday_Newcastle": "NEW",
    "Matchday_Tottenham": "TOT",
    "Matchday_West Ham": "WHA",
    "Matchday_United": "UTD",
    "Matchday_Leeds": "LEE",
    "Matchday_Liverpool": "LIV",
    "Matchday_Everton": "EVE",
    "Matchday_Aston": "AST",

    //Matchday Turkish Teams
    "Matchday_Basaksehir": "BAS",
    "Matchday_Trabzon": "TRZ",
    "Matchday_Besiktas": "BKS",
    "Matchday_Sivas": "SIV",
    "Matchday_Alanya": "ALA",
    "Matchday_Galata": "GLS",
    "Matchday_Fenerbahce": "FRB",
    "Matchday_Gazientep": "GAZ",
    "Matchday_Antalya": "ANT",
    "Matchday_Kasimpasa": "KAS",
    "Matchday_Goztepe": "GOZ",
    "Matchday_Gencler": "ESK",
    "Matchday_Konya": "BUR",
    "Matchday_Rize": "RIZ",
    "Matchday_Malatya": "MAL",
    "Matchday_Kayseri": "KAY",

    //Matchday Greek Teams
    "Matchday_Dikefalos Vora": "ΔΙΚ",
    "Matchday_Erithrolefkoi": "ΘΡΥ",
    "Matchday_Enosi": "ΕΝΩ",
    "Matchday_Peristeri": "ΠΕΡ",
    "Matchday_Prasinoi": "ΠΡΑ",
    "Matchday_Kitrinoi Vora": "ΚΙΤ",
    "Matchday_Nea Smirni": "ΣΜΥ",
    "Matchday_Xanthi": "ΞΑΝ",
    "Matchday_Tripoli": "ΤΡΙ",
    "Matchday_Agrinio": "ΑΓΡ",
    "Matchday_Larisa": "ΛΑΡ",
    "Matchday_Lamia": "ΛΑΜ",
    "Matchday_Ioannina": "ΙΩΑ",
    "Matchday_Iraklio": "ΗΡΑ",
    "Matchday_A.O. Rizoupolis": "ΡΙΖ",
    "Matchday_Volos": "ΒΟΛ",

    //Soccer3 Greek Teams
    "Dikefalos Vora": "ΔΙΚ",
    "Erithrolefkoi": "ΘΡΥ",
    "Enosi": "ΕΝΩ",
    "Peristeri": "ΠΕΡ",
    "Prasinoi": "ΠΡΑ",
    "Kitrinoi Vora": "ΚΙΤ",
    "Nea Smirni": "ΣΜΥ",
    "Xanthi": "ΞΑΝ",
    "Tripoli": "ΤΡΙ",
    "Agrinio": "ΑΓΡ",
    "Larisa": "ΛΑΡ",
    "Lamia": "ΛΑΜ",
    "Ioannina": "ΙΩΑ",
    "Iraklio": "ΗΡΑ",
    "A.O. Rizoupolis": "ΡΙΖ",
    "Volos": "ΒΟΛ",

    "Dortmund": "Dortmund",
    "Chelsea": "Chelsea",
    "Porto": "Porto",
    "Rome": "Rome",
    "Benfica": "Benfica",
    "Celtic": "Celtic",
    "United": "United",
    UNDER_OVER_MATCHDAY: 'Բարձր/ցածր',
    UNDER_OVER_05_SHORT: "0.5",
    UNDER_OVER_15_SHORT: "1.5",
    UNDER_OVER_25_SHORT: "2.5",
    UNDER_OVER_35_SHORT: "3.5",
    UNDER_SHORT: "Շատ",
    OVER_SHORT: "Քիչ",
    "FULL TIME": "ԼՐԻՎ ԺԱՄԱՆԱԿ",
    "FT": "FT",
    "System": "ՀԱՄԱԿԱՐԳ",
    "x1": "(x1)",
    "Multiplier": "Repeat Bet",
    "Main markets": "ՀԻՄՆԱԿԱՆ ՇՈՒԿԱՆԵՐ",
    "4RANDOM": "4 ՊԱՏԱՀԱԿԱՆ",
    "6RANDOM": "6 ՊԱՏԱՀԱԿԱՆ",
    "8RANDOM": "8 ՊԱՏԱՀԱԿԱՆ",
    "8FAVS": "8 ԸՆՏՐՎԱԾ",
    "QUICK_SELECT": "ԱՐԱԳ ԸՆՏՐՈՒԹՅՈՒՆ",
    "UNDER": "ցածր",
    "OVER": "Բարձր",
    "UNDER_OVER_2_5": "Բարձր/ցածր 2.5",
    "UNDER_OVER_3_5": "Բարձր/ցածր 3.5",
    "MATCH_RESULT": "Խաղի արդյունք",
    "YES": "Այո",
    "NO": "Ոչ",
    "REALITY_CHECK_WARNING_YES": "Այո",
    "REALITY_CHECK_WARNING_NO": "Ոչ",
    "ACCUMULATOR": "Կուտակիչ",
    "+1G": "+1G",
    "Single": "Մեկ",
    "Doubles": "Կրկնակի(ներ)",
    "Trebles": "Թրեբլ(ներ)",
    "Four Folds": "4 անգամ",
    "Five Folds": "5 անգամ",
    "Six Folds": "6 անգամ",
    "Seven Folds": "7 անգամ",
    "Eight Folds": "8 անգամ",
    "MD": "MD{0}",
    "MATCH": "ԽԱՂ",
    "INVALID_ACCA": "Եթե Ձեր ընտրած տարբերակները ընդգծված են, Ձեր բազմակի ընտրությունը սահմանափակ է:",
    "INVALID_ODDS": "Գործակցի արժեքը չափազանց բարձր է: Խնդրում ենք փոխել ընտրությունը",
    "INVALID_ACCA_MORETHAN_8": "Բազմակի խաղադրույքները չեն կարող պարունակել ավելի քան 8 ընտրություն մեկ Խաղից",

    // Accumulator Boost
    "ACCUMULATOR_BOOST": 'Կուտակիչի խթանում',
    "Bonus_Info": " {0}% բոնուս",
    "+": "+",
    "Bonus_Value": "Ներառյալ {0} բոնուս",
    "ACCUMULATOR_INFO": 'Եթե Ձեր կուտակիչ խաղադրույքը շահել է, ապա շահումին ավելացվում է {0}% - {1}% բոնուս: Բոնուսի գումարը կախված է ընտրությունների քանակից:',
    "BET_TYPE": 'Խաղադրույքի տեսակ',
    "BOOST": 'Խթանել',
    "BOOST_PERCENTAGE": '{0}%',
    "BOOST_BONUS_START": '{0} կամ ավելի ընտրության կուտակիչ կստանա բոնուս',
    "BOOST_BONUS_UPGRADE": 'Լրացուցիչ բոնուս ստանալու համար ավելացրեք Կուտակիչ խաղադրույքին մեկ այլ ընտրություն',
    "BOOST_BONUS_MAX": 'Դուք ունեք առավելագույն կուտակային բոնուս',
    "Marbles_Euro_1": "Belgium",
    "Marbles_Euro_2": "Croatia",
    "Marbles_Euro_3": "Denmark",
    "Marbles_Euro_4": "England",
    "Marbles_Euro_5": "France",
    "Marbles_Euro_6": "Germany",
    "Marbles_Euro_7": "Italy",
    "Marbles_Euro_8": "Netherlands",
    "Marbles_Euro_9": "Portugal",
    "Marbles_Euro_10": "Spain",
    "Short_Over": "Բարձր {0}",
    "Short_Under": "ցածր {0}",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1": "Խնդրում ենք գրանցվել կամ մուտք գործել՝ խաղադրույք կատարելու համար",
    "DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2": " ",
    "DEMOPLAY_NOTIFICATION_DISMISS": "Հեռացնել",
    "DEMOPLAY_NOTIFICATION_OK": "OK",
    "Matchday_Moroccan": "Matchday Moroccan",
    "Matchday_Moroccan_Matchday_Moroccan": "Matchday Moroccan",
    "betSlip_Matchday_Moroccan": "Matchday Moroccan",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    "QUICK_FILL": "Quick Fill",
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Խաղի օր",
    "Matchday_Belgium_Matchday_Belgium": "Խաղի օր",
    "betSlip_Matchday_Belgium": "Matchday Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading": "ՆՎԵՐ ՁԵԶ ՀԱՄԱՐ",
    "Gift_for_You_Content": "Շնորհավորում եմ: Դուք ունեք պրոմո առաջարկներ, որոնք կարող եք օգտագործել.",
    "View_Offers": "ԴԻՏԵԼ ԱՌԱՋԱՐԿՆԵՐԸ",
    "Do_Not_Show_MSG": "Այլևս ցուցմունք չտալ",
    "MY_OFFERS": "ԻՄ ԱՌԱՋԱՐԿՆԵՐԸ",
    "SELECT_OFFER": "ԸՆՏՐԵՔ ՁԵՐ ԱՌԱՋԱՐԿԸ",
    "NO_OFFER": "ԱԿՏԻՎ ԱՌԱՋԱՐԿՆԵՐ ՉԿԱՆ",
    "CHOOSE_BET": "ԸՆՏՐԵԼ ԽԱՂԱԴՐՈՒՅՔ",
    "Opt_In": 'ՄԻԱՆԱԼ',
    "Key_Terms_Heading" :"ՀԻՄՆԱԿԱՆ ՊԱՅՄԱՆՆԵՐ",
    "No_Thanks" : "ՈՉ, ՇՆՈՐՀԱԿԱԼՈՒԹՅՈՒՆ",
    "PROMO_BET": ' ՊՐՈՄՈ ԽԱՂԱԴՐՈՒՅՔ',
    "Time_To_Bet": " ԽԱՂԱԴՐՈՒՅՔԻ ԺԱՄԱՆԱԿՆ Է",
    "OPTED_IN_MSG": " ՇՆՈՐՀԱԿԱԼՈՒԹՅՈՒՆ, ՈՐ ՄԻԱՑԵԼ ԵՔ",
    "EXP": " Ժամկետը լրանում է",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Կրիկետ",
    "Cricket_International": "Միջազգային",
    "betSlip_Cricket": "Կրիկետ",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":" Թայ",
    //cricket markets
     "MATCH_WINNER":"Խաղի հաղթող",
     "TOTAL_SIXES_IN_MATCH":"Ընդհանուր խաղ 6",
     "TOTAL_SIXES_IN_MATCH_SHORT": "ցածր 1.5",
     "TOTAL_FOUR_IN_MATCH":"Ընդհանուր խաղ 4",
     "TOTAL_BOUNDARIES_IN_MATCH":"Ընդհանուր խաղ, սահմաններ",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Ռաների ընդհանուր քանակ",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"{0} Ռաների քանակը առաջին մատուցումից ",
     "FIRST_TEAM_WICKET_LOST":"{0} Վիկետի կորուստ",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Առաջին վիկետ",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Ռաների քանակը առաջին մատուցումից  (O/U)",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Ռաների քանակը առաջին մատուցումից  (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Ռաների քանակը առաջին մատուցումից  (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Ռաների քանակը առաջին մատուցումից  (O/U)",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Ռաների քանակը առաջին մատուցումից  (O/U)",
     "Caught" : "Բռնվել է",
     "Bowled":"Դուրս գալ",
     "LBW":"LBW",
     "No Wicket":"Վիկետ չկա",
     "OverZeroPointFive": "Բարձր 0.5",
     "UnderZeroPointFive": "ցածր 0.5",
     "OverOnePointFive": "Բարձր 1.5",
     "UnderOnePointFive": "ցածր 1.5",
     "OverTwoPointFive": "Բարձր 2.5",
     "UnderTwoPointFive": "ցածր 2.5",
     "OverThreePointFive": "Բարձր 3.5",
     "UnderThreePointFive": "ցածր 3.5",
     "Yes": "Այո",
     "No":"Ոչ",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Բարձր 14.5',
     UNDER_145: 'ցածր 14.5',
     DRAW_Cricket: "Ոչ ոքի",

    //TENNIS
    TOTAL_POINTS:"Ռաների ընդհանուր քանակ ",
    HANDICAP_TENNIS: " Հանդիկապ",
    Scotland :"Scotland",
    USA: "USA",
    Tennis_International: "Միջազգային",
    betSlip_Tennis: " Թենիս",
    "Win By 2 or 3": "Հաղթել 3 միավորով կամ ավելի քիչ",
    "Win By 4 or 5": "Հաղթել 4 կամ 5 միավորով",
    "Win By 6 or 7": " Հաղթեք 6 կամ 7 միավորով",
    "Tennis": " Թենիս",
   //baseball
    WINNER : " ՀԱՂԹՈՂ",
    TOTAL_HOME_RUNS_UNDER_OVER: "ՀՈՄ-ՌԱՆԵՐԻ ԸՆԴՀԱՆՈՒՐ ՔԱՆԱԿԸ ՇԱՏ/ՔԻՉ",
    TOTAL_HOME_RUNS:  "ՀՈՄ-ՌԱՆԵՐԻ ԸՆԴՀԱՆՈՒՐ ՔԱՆԱԿԸ ՃՇԳՐԻՏ",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"ՀԱՂԹՈՂ ԵՎ ՀՈՄ-ՌԱՆԵՐԻ ԸՆԴՀԱՆՈՒՐ ՔԱՆԱԿԸ ՇԱՏ/ՔԻՉ 5.5",
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Հաղթող և Հոմ-ռաների ընդհանուր քանակը Շատ/Քիչ 5.5",
    BATTER1_HOME_RUNS: "{0} ՀՈՄ-ՌԱՆԵՐ",
    BATTER2_HOME_RUNS: "{1} ՈՈՒՄ ՌԱՆ",
    Baseball_HR_ShootOut_Legends: "Հոմ-ռաներ խփած լեգենդներ",
    Baseball_HR_ShootOut_Legends_SHORT: "ՀՌ խփած",
    "Baseball": "Բեյսբոլ",
    "betSlip_Baseball": "Բեյսբոլ",
    "Player 1 AND OVER_5_5":"{0} և Շատ 5.5-ից",
    "Player 2 AND OVER_5_5":"{0} և Շատ 5.5-ից",
    "Player 1 AND UNDER_5_5":"{0} և Քիչ 5.5-ից",
    "Player 2 AND UNDER_5_5":"{0} և Քիչ 5.5-ից",
    "Draw AND OVER_5_5":"Թայ և Շատ 5.5-ից",
    "Draw AND UNDER_5_5":"Թայ և Քիչ 5.5-ից",
    "HOME RUNS":"{0} ՀՈՄ-ՌԱՆԵՐ",
    "Next Fixtures":"Next Fixtures",
    "MATCH_IN_PROGRESS": "Match In Progress",
    "Matchday_Light_English": "Matchday Light",
    "Matchday_Light_English_Matchday_Light_English": "English League",
    "betSlip_Matchday_Light_English": "Matchday Light",
    //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",
  //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "Ռաների ընդհանուր քանակ "

};


// WEBPACK FOOTER //
// ./src/localization/hy_AM.js